import { type Messages } from ".";

export const messagesES: Messages = {
  HOME: {
    TITLE: "Panel",
    ROUTE: "/dashboard",
    PAGE: "Bienvenido a DASF",
    INTRO: "Un marco potente para la evaluación de la gestión de desastres",
    SECTION1_TITLE: "Funcionalidades",
    SECTION1:
      "Esta aplicación apoya la evaluación de capacidades en gestión de desastres.",
    SECTION2_TITLE: "Tecnología",
    SECTION2: "Construido con TypeScript y tecnologías web modernas.",
    SECTION3_TITLE: "Uso",
    SECTION3: "Navegue por las secciones utilizando la barra de navegación.",
  },
  ABOUT: {
    TITLE: "Acerca de",
    ROUTE: "/about",
    PAGE: "Acerca de DASF",
    INTRO:
      "Más información sobre el DIREKTION Assessment & Screening Framework",
    SECTION1_TITLE: "Qué es DASF",
    SECTION1:
      "El DIREKTION Assessment & Screening Framework ayuda a las organizaciones en gestión de desastres.",
    SECTION2_TITLE: "Características principales",
    SECTION2:
      "Evaluación de capacidades, identificación de brechas, evaluación de soluciones y hoja de ruta.",
    SECTION3_TITLE: "Objetivos de desarrollo",
    SECTION3:
      "Proporcionar un marco claro y mantenible para la gestión de desastres.",
  },
  SETTINGS: {
    TITLE: "Configuración",
    ROUTE: "/settings",
    PAGE: "Configuración de la aplicación",
    INTRO: "Configure sus preferencias de aplicación",
    SECTION1_TITLE: "Preferencias de idioma",
    SECTION1: "Cambie entre los idiomas disponibles.",
    SECTION2_TITLE: "Configuración de apariencia",
    SECTION2: "Personalice la apariencia visual de la aplicación.",
    SECTION3_TITLE: "Preferencias",
    SECTION3: "Administre el comportamiento de la aplicación.",
  },
  LANDING: { TITLE: "Introducción", ROUTE: "/" },
  HAZARDS: { TITLE: "Amenazas", ROUTE: "/hazards" },
  SOLUTIONS: { TITLE: "Soluciones", ROUTE: "/solutions" },
  ROADMAP: { TITLE: "Hoja de ruta", ROUTE: "/roadmap" },
  USER: "Usuario",
  EDITOR: "Editor",
  ADMIN: "Administrador",
  CANCEL: "Cancelar",
  DELETE: "Eliminar",
  YES: "Sí",
  NO: "No",
  OK: "Aceptar",
  NAME: "Nombre",
  DESCRIPTION: "Descripción",
  DELETE_ITEM: {
    TITLE: "Eliminar {item}",
    DESCRIPTION:
      "¿Está seguro de que desea eliminar este {item}? No hay vuelta atrás.",
  },
  SAVE_BUTTON: {
    LABEL: "Guardar",
    TOOLTIP: "Guardar cambios no guardados",
  },
  SEARCH: "Buscar...",
  SEARCH_TOOLTIP: "Escriba / para buscar",
  LANGUAGE: "Idioma",
  CLEAR: "Borrar modelo",
  UPLOAD: "Cargar modelo como JSON",
  DOWNLOAD: "Descargar modelo como JSON",
  PERMALINK: "Crear enlace permanente",
  ROLE: "Rol",
  LINK: "Enlace",
  MODEL: "Modelo",
  TITLE: "Título",
  AUTHORS: "Autores",
  TYPE: "Tipo",
  HITS: {
    n: "{n} Resultados",
  },
  NO_RESULTS: "No se encontraron resultados",
  CLEAR_SEARCH: "Limpiar búsqueda",
  PAGE_NOT_FOUND: "Página no encontrada",

  about_route: "/about",
  about: "Acerca de",
  acronym: "Acrónimo",
  add_term: "Añadir un nuevo término",
  addr_how: "¿Cómo se aborda?",
  addressed: "Abordado",
  ass_instr: "_Evalúe la contribución de una capacidad a sus objetivos._",
  ass_label: "La causa del problema es bien conocida",
  ass_overall: "Necesidad de mejora",
  ass_scale: "Escala para la puntuación de evaluación",
  ass_setting: "Matriz de evaluación",
  ass: "Evaluación",
  assess_content:
    "Determine para cada capacidad su importancia y su rendimiento actual.",
  assess: "Evaluar",
  assessment_route: "/assessment/:id",
  assessment: "Evaluación",
  avg_perf: "Evaluación general",
  cap_cat: "Categoría de capacidad",
  cap: "Capacidad",
  caps: "Capacidades",
  cat: "Categoría",
  clear_all: "Limpiar todos los filtros",
  clear: "Limpiar",
  color: "Color",
  create_cap: "Crear capacidad",
  defs: "Definiciones",
  del_model: "¿Realmente desea eliminar todo?",
  del_model_desc: "¿Está seguro de que desea eliminar su modelo?",
  del_proj: "Eliminar proyecto",
  desc_cap_instr: "Describa la capacidad en detalle.",
  desc: "Descripción",
  develop_content: "Comience a desarrollar sus capacidades.",
  develop: "Desarrollar",
  development: "Desarrollo",
  development_route: "/development/:id",
  dev_cap:
    "_Sugiera nuevos proyectos para desarrollar su capacidad. Empiece seleccionando una capacidad._",
  doc_id: "ID del documento",
  doc: "Documentación",
  download: "Descargar",
  duration: "Duración",
  edit: "Editar",
  view: "Ver",
  evaluation_route: "/evaluation/:id",
  evaluation: "Evaluación",
  exp_perf: "Rendimiento esperado",
  expl: "Explicación",
  expl2: "Rendimiento",
  filter_cap: "Filtrar capacidades",
  filter_caps: "Filtrar capacidades",
  filter_ph: "Título o descripción",
  filter_text_ph: "Término o descripción",
  filter_text: "Texto de filtro",
  filters: "Filtros",
  relevance: "Relevancia",
  gap_scale: "Escala para la brecha",
  gap_settings: "##### Configuración de brechas",
  gap: "Brecha",
  gaps_common: "Brechas comunes o causas de problemas",
  gaps: "Brechas",
  gng: "###### Decisión GO / NO GO<br>",
  go: "GO",
  goal_scale: "Escala para los temas de evaluación",
  goals_instr: "Especificar objetivos a largo y corto plazo",
  goal: "Objetivo",
  goals: "Objetivos",
  group_goals_instr:
    "1. **Establezca los objetivos de grupo que desea alcanzar.**\n2. Especifique sus partes interesadas y sus objetivos organizacionales.\n3. Especifique categorías de capacidades para organizar las capacidades.\n4. Especifique las capacidades que necesita para alcanzar los objetivos de grupo.",
  group_goals: "Especificar objetivos de grupo",
  home_route: "/",
  home: "INICIO",
  id: "ID",
  importance: "Importancia",
  in_months: "En meses",
  loc: "Sala/ubicación",
  main_goals: "Objetivos",
  assess_capability_importance_for_capability:
    'Evalúe la importancia de "{capability}" para el alcance elegido.',
  max_imp: "Contribución máxima",
  name: "Nombre",
  no_go: "NO GO",
  no: "No",
  org_dept: "Organización / Departamento",
  overview_route: "/overview",
  overview: "Vista general",
  level: "Nivel",
  perf_asp: "Aspecto de rendimiento",
  perf_asps: "Aspectos de rendimiento",
  assess_performance_aspects_for_capability:
    "Evalúe los aspectos de rendimiento de {capability}.",
  perf_effectiveness_tooltip: "¿Qué tan efectiva es {capability}?",
  perf_safety_professionals_tooltip:
    "¿Cuál es el nivel de seguridad física y mental del personal operativo que trabaja en {capability}?",
  perf_efficiency_tooltip: "¿Qué tan eficiente es {capability}?",
  perf_scale: "Escala para puntuación de rendimiento",
  perf_settings: "##### Configuración de evaluación",
  perf: "Rendimiento",
  period: "AAAA T1 o AAAA M1",
  permalink: "Enlace permanente",
  pers_inv: "Personas implicadas",
  pick_more: "Elegir uno o más",
  pick_one: "Elegir uno",
  prep_content: "_Defina los objetivos de su organización._",
  preparation_route: "/objectivos",
  preparation: "Objetivos",
  prepare_content: "Cree o seleccione las capacidades importantes.",
  prepare: "Preparar",
  prob_areas: "Áreas problemáticas",
  gap_problem_categories_intro:
    "Analice esta brecha de capacidad en las siguientes categorías de problemas.",
  gap_likert_severity: "Severidad",
  gap_likert_severity_start_label: "Muy baja",
  gap_likert_severity_middle_label: "Promedio",
  gap_likert_severity_end_label: "Muy alta",
  gap_likert_probability: "Probabilidad",
  gap_likert_probability_start_label: "Sin cambio",
  gap_likert_probability_middle_label: "—",
  gap_likert_probability_end_label: "Gran disminución",
  gap_likert_impact: "Impacto",
  gap_likert_impact_start_label: "Sin cambio",
  gap_likert_impact_middle_label: "—",
  gap_likert_impact_end_label: "Gran disminución",
  gap_likert_severity_tooltip:
    "¿Cómo valora la severidad de esta brecha de capacidad?",
  gap_likert_probability_tooltip:
    "Suponga que la brecha se resuelve: ¿qué significaría esto para la probabilidad de ocurrencia de la brecha?",
  gap_likert_impact_tooltip:
    "Suponga que la brecha se resuelve. ¿Qué significaría esto para la reducción del impacto de la brecha original?",
  prob: "Problema",
  proj_app: "###### PROYECTO APROBADO<br>",
  proj_name: "Nombre del proyecto",
  proj_prop: "Nuevo proyecto o propuesta",
  proj_sum: "Resumen del proyecto",
  prop_name: "Nombre de la propuesta",
  prop_new: "Nueva propuesta",
  ref: "Referencia",
  ref_url: "URL de referencia",
  select_cap: "Seleccionar capacidad",
  select_cat: "Seleccionar categoría",
  select_m_ph: "Seleccionar uno o más",
  select_subcat: "Seleccionar subcategoría",
  settings_route: "/settings",
  settings: "Configuración",
  sh_filter: "Filtrar organizaciones implicadas",
  sh_org: "Organizaciones partes interesadas",
  sh_settings: "##### Configuración de partes interesadas",
  sh_type: "Tipo de parte interesada",
  sh_types: "Tipos de partes interesadas",
  sh: "Parte interesada",
  shs: "Partes interesadas",
  other_stakeholder: "Por favor describa la otra parte interesada",
  spec_cap_instr:
    "1. Establezca los objetivos de grupo que desea alcanzar.\n2. Especifique sus partes interesadas y sus objetivos organizacionales.\n3. Especifique categorías de capacidades para organizar las capacidades.\n4. **Especifique las capacidades que necesita para alcanzar los objetivos de grupo.**",
  spec_cap: "Especificar capacidades",
  spec_cat_instr:
    "1. Establezca los objetivos de grupo que desea alcanzar.\n2. Especifique sus partes interesadas y sus objetivos organizacionales.\n3. **Especifique categorías de capacidades para organizar las capacidades.**\n4. Especifique las capacidades que necesita para alcanzar los objetivos de grupo.",
  spec_cat: "Especificar categorías",
  spec_sh_instr:
    "1. Establezca los objetivos de grupo que desea alcanzar.\n2. **Especifique sus partes interesadas y sus objetivos organizacionales.**\n3. Especifique categorías de capacidades para organizar las capacidades.\n4. Especifique las capacidades que necesita para alcanzar los objetivos de grupo.",
  spec_sh: "Especificar partes interesadas",
  start_time: "Hora de inicio",
  subcat: "Subcategoría",
  task_settings: "##### Configuración de tareas",
  task: "Tarea",
  task2perf: "##### Tabla de correspondencia tarea-rendimiento",
  tasks: "Tareas",
  ass_task_scale: "Escala de tareas",
  ass_perf_scale: "Rendimiento",
  taxonomy_route: "/taxonomy",
  taxonomy: "Taxonomía",
  tax_def:
    "#### Taxonomía\n\nDefiniciones y abreviaturas de términos de uso común.",
  TAXONOMY: {
    HAZARD: "Amenaza",
    HAZARD_DEF:
      "Un proceso, fenómeno o actividad humana que puede causar pérdida de vidas, lesiones, perturbaciones o daños ambientales.",
    HAZARD_TYPE: "Tipo de amenaza",
    HAZARD_TYPE_DEF:
      "Una clase de amenazas con origen o características similares, como amenazas naturales, tecnológicas o de origen humano.",
    DISASTER: "Desastre",
    DISASTER_DEF:
      "Una perturbación grave de una comunidad o sociedad que supera su capacidad para hacer frente con sus propios recursos.",
    EMERGENCY: "Emergencia",
    EMERGENCY_DEF:
      "Una situación que requiere acción coordinada inmediata para proteger la vida, la salud, los bienes o el medio ambiente.",
    DISASTER_RISK: "Riesgo de desastre",
    DISASTER_RISK_DEF:
      "El potencial de pérdidas por eventos peligrosos, determinado por la amenaza, la exposición, la vulnerabilidad y la capacidad.",
    EXPOSURE: "Exposición",
    EXPOSURE_DEF:
      "La presencia de personas, bienes, infraestructuras y servicios en lugares donde pueden ocurrir amenazas.",
    VULNERABILITY: "Vulnerabilidad",
    VULNERABILITY_DEF:
      "Condiciones que aumentan la susceptibilidad de las personas, bienes o sistemas a los impactos de las amenazas.",
    CAPACITY: "Capacidad",
    CAPACITY_DEF:
      "Las fortalezas y recursos disponibles para anticipar, hacer frente, resistir y recuperarse de los impactos de las amenazas.",
    CAPABILITY: "Aptitud",
    CAPABILITY_DEF:
      "Una capacidad específica y demostrable de una organización para realizar tareas y lograr resultados en condiciones definidas.",
    RESILIENCE: "Resiliencia",
    RESILIENCE_DEF:
      "La capacidad de los sistemas y comunidades para resistir, absorber, adaptarse y recuperarse mientras se preservan las funciones esenciales.",
    PREVENTION: "Prevención",
    PREVENTION_DEF:
      "Acciones para evitar la creación de nuevos riesgos y prevenir que las amenazas causen impactos perjudiciales.",
    MITIGATION: "Mitigación",
    MITIGATION_DEF:
      "Medidas que reducen la gravedad o probabilidad de impactos adversos de eventos peligrosos.",
    PREPAREDNESS: "Preparación",
    PREPAREDNESS_DEF:
      "Conocimientos, planes y capacidades desarrollados con anticipación para permitir una anticipación, respuesta y recuperación efectivas.",
    EARLY_WARNING_SYSTEM: "Sistema de alerta temprana",
    EARLY_WARNING_SYSTEM_DEF:
      "Un sistema integrado para monitorear amenazas, evaluar riesgos, comunicar alertas y permitir acciones oportunas.",
    RESPONSE: "Respuesta",
    RESPONSE_DEF:
      "Acciones tomadas justo antes, durante o inmediatamente después de un evento para salvar vidas y atender necesidades urgentes.",
    RECOVERY: "Recuperación",
    RECOVERY_DEF:
      "El proceso de restauración y mejora de los medios de vida, servicios, infraestructuras y sistemas después de un desastre.",
    BUILD_BACK_BETTER: "Reconstruir mejor",
    BUILD_BACK_BETTER_DEF:
      "Usar la recuperación y reconstrucción para reducir riesgos futuros y mejorar la resiliencia más allá de las condiciones previas al desastre.",
    CONTINGENCY_PLANNING: "Planificación de contingencia",
    CONTINGENCY_PLANNING_DEF:
      "Preparación de planes operativos específicos y modalidades de coordinación para escenarios de emergencia plausibles.",
    RISK_ASSESSMENT: "Evaluación de riesgos",
    RISK_ASSESSMENT_DEF:
      "Un proceso estructurado para identificar amenazas, analizar consecuencias y estimar riesgos para apoyar decisiones.",
    RISK_COMMUNICATION: "Comunicación de riesgos",
    RISK_COMMUNICATION_DEF:
      "Intercambio bidireccional de información sobre riesgos entre autoridades, intervinientes, partes interesadas y el público.",
    SITUATION_AWARENESS: "Conciencia situacional",
    SITUATION_AWARENESS_DEF:
      "Una comprensión actual y compartida de las condiciones del incidente, impactos, recursos y desarrollos probables.",
    INCIDENT_COMMAND: "Mando de incidente",
    INCIDENT_COMMAND_DEF:
      "Una estructura de mando y coordinación para gestionar roles, decisiones y recursos durante incidentes.",
    STAKEHOLDER: "Parte interesada",
    STAKEHOLDER_DEF:
      "Cualquier organización, grupo o individuo con un rol, responsabilidad o interés en la preparación, respuesta o recuperación.",
    INTEROPERABILITY: "Interoperabilidad",
    INTEROPERABILITY_DEF:
      "La capacidad de organizaciones, equipos y sistemas para trabajar juntos eficazmente a través de procedimientos, datos y tecnología.",
    CAPABILITY_GAP: "Brecha de capacidad",
    CAPABILITY_GAP_DEF:
      "La diferencia entre los niveles de capacidad requeridos y actuales necesarios para lograr los resultados objetivo.",
    CAPABILITY_ASSESSMENT: "Evaluación de capacidades",
    CAPABILITY_ASSESSMENT_DEF:
      "Una evaluación estructurada de la importancia y el rendimiento de las capacidades para identificar prioridades de mejora.",
    SOLUTION: "Solución",
    SOLUTION_DEF:
      "Una medida, práctica, tecnología o intervención propuesta para abordar una o más brechas de capacidad.",
    SOLUTION_ASSESSMENT: "Evaluación de soluciones",
    SOLUTION_ASSESSMENT_DEF:
      "Una valoración sistemática de soluciones candidatas frente a necesidades de usuarios, adecuación operativa, impacto y cumplimiento.",
    ROADMAP: "Hoja de ruta",
    ROADMAP_DEF:
      "Un plan de implementación por fases que muestra qué se entregará, por quién y cuándo.",
    IMPLEMENTATION_TIMELINE: "Cronograma de implementación",
    IMPLEMENTATION_TIMELINE_DEF:
      "La secuencia y calendario planificados de actividades, hitos y entregables para la implementación.",
    PRIORITIZATION: "Priorización",
    PRIORITIZATION_DEF:
      "Clasificación de acciones o inversiones basada en urgencia, impacto esperado, viabilidad y recursos disponibles.",
    MONITORING_EVALUATION: "Seguimiento y evaluación",
    MONITORING_EVALUATION_DEF:
      "Seguimiento continuo y revisión periódica del progreso, resultados y efectividad para apoyar el aprendizaje y el ajuste.",
    LESSONS_LEARNED: "Lecciones aprendidas",
    LESSONS_LEARNED_DEF:
      "Conocimientos documentados de operaciones y ejercicios utilizados para mejorar la planificación y el rendimiento futuros.",
    SESSION: "Sesión de evaluación",
    SESSION_DEF:
      "Un contexto de trabajo guardado que contiene amenazas seleccionadas, evaluaciones, soluciones y datos de hoja de ruta.",
    COMPLIANCE_CHECK: "Verificación de cumplimiento",
    COMPLIANCE_CHECK_DEF:
      "Una verificación de que las soluciones y acciones propuestas cumplen con los requisitos legales, políticos, éticos y sectoriales.",
    TECHNOLOGY_READINESS_LEVEL: "Nivel de madurez tecnológica",
    TECHNOLOGY_READINESS_LEVEL_DEF:
      "Una escala del 1 al 9 que indica la madurez de una tecnología desde el concepto hasta el despliegue operativo.",
  },
  term: "Término",
  title: "Título",
  upload: "Cargar",
  url: "URL",
  value: "Valor",
  yes: "Sí",
  TBD: "Desconocido",
  general_settings: "General",
  enable_sol_ass_support: "Evaluación de soluciones habilitada",
  logo: "Logo de usuario",
  attribution_logo: "Logo de atribución",
  attribution_text: "Texto de atribución",
  order: "Orden",
  hide: "Ocultar en vista general",
  select_user: "Seleccionar usuario",
  user: "Usuario estándar",
  moderator: "Moderador",
  admin: "Administrador",
  doc_title: "Informe de evaluación de capacidades",
  export_to_word: "Exportar a Word",
  export_all_to_word: "Exportar informe completo a Word",
  add_gap: "Añadir brecha de capacidad",
  ignore: "No aplicable",
  continue: "Continuar",
  hazards: "Amenazas",
  hazards_route: "/hazards",
  hazard_step_title: "Paso 0: Iniciación y Preparación",
  hazard_step_desc:
    "Seleccione los tipos de amenazas relevantes para el ámbito que desea abordar en este taller de evaluación.",
  workshop_scope: "Ámbito del taller",
  hazard_category_all: "Todos",
  hazard_category_natural: "Natural",
  hazard_category_technical: "Técnico",
  hazard_category_attack: "Ataque",
  hazard_edit: "Editar tipos de amenazas",
  hazard_done: "Finalizar edición",
  hazard_add: "Añadir nuevo tipo de amenaza",
  hazard_name: "Nombre de la amenaza",
  hazard_description: "Descripción / contexto",
  hazard_selected_count: "{n} tipo(s) de amenaza seleccionado(s).",
  solutions: "Soluciones",
  solution_count: {
    1: "1 solución",
    n: "{n} soluciones",
  },
  solutions_route: "/solutions",
  solutions_step_title: "Paso 2: Evaluación de soluciones",
  solutions_step_desc:
    "Añadir y evaluar soluciones para las brechas identificadas.",
  solution_add: "Añadir solución",
  solution_new: "Nueva solución",
  solution_gaps_found: {
    1: "1 brecha de capacidad identificada",
    n: "{n} brechas de capacidad identificadas",
  },
  solution_empty:
    "No se han añadido soluciones todavía. Haga clic en 'Añadir solución' para comenzar.",
  roadmap: "Hoja de ruta",
  roadmap_count: {
    1: "1 elemento de hoja de ruta",
    n: "{n} elementos de hoja de ruta",
  },
  roadmap_route: "/roadmap",
  roadmap_step_title: "Paso 3: Hoja de ruta",
  roadmap_step_desc: "Planificar calendarios de implementación y compromisos.",
  roadmap_add_solutions: "Añadir {n} solución(es) a la hoja de ruta",
  roadmap_empty_solutions:
    "Complete primero el paso 2 (Evaluación de soluciones) para añadir soluciones a la hoja de ruta.",
  roadmap_empty: "No hay elementos en la hoja de ruta.",
  roadmap_timeline: "Cronograma",
  session_create: "Crear",
  session_new_name: "Nombre de la nueva sesión",
  session_sessions: "Sesiones de evaluación",
  session_name: "Nombre",
  session_updated: "Última actualización",
  session_actions: "Acciones",
  session_clone: "Clonar sesión",
  session_download: "Descargar como JSON",
  session_delete: "Eliminar sesión",
  session_import: "Importar JSON",
  session_delete_confirm: "¿Eliminar sesión: {name}?",
  session_delete_warning: "Esta acción no se puede deshacer. ¿Está seguro?",
  dashboard_subtitle:
    "Siga los pasos a continuación para completar su evaluación de gestión de desastres.",
  back_to_sessions: "Volver a las sesiones",
  step0_title: "Iniciación y Preparación",
  step1_title: "Evaluación de necesidades y brechas",
  step2_title: "Evaluación de soluciones",
  step3_title: "Hoja de ruta",
  summary: "Resumen",
  selected_hazards: "Amenazas seleccionadas",
  capability_gaps: "Brechas de capacidad",
  more: "más",
  partially: "Parcialmente",
  not_assessed: "No evaluado",
  enabled_steps: "Pasos habilitados",
  priority_low: "Bajo",
  priority_medium: "Medio",
  priority_high: "Alto",
  sol_trl: "Nivel de madurez tecnológica",
  trl1: "Principios básicos observados",
  trl2: "Concepto tecnológico formulado",
  trl3: "Prueba de concepto experimental",
  trl4: "Tecnología validada en laboratorio",
  trl5: "Tecnología validada en entorno relevante",
  trl6: "Tecnología demostrada en entorno relevante",
  trl7: "Prototipo de sistema demostrado en entorno operativo",
  trl8: "Sistema completo y calificado",
  trl9: "Sistema real probado en entorno operativo",
  sol_integration_rl: "Nivel de preparación para la integración",
  sol_societal_rl: "Nivel de preparación social",
  sol_manufacturing_rl: "Nivel de preparación para la fabricación",
  sol_commercialisation_rl: "Nivel de preparación para la comercialización",
  sol_security_rl: "Nivel de preparación para la seguridad",
  sol_legal_privacy_ethical_rl:
    "Nivel de preparación jurídica, de privacidad y ética",
  integration_rl1:
    "Se ha identificado un concepto de alto nivel para la integración",
  integration_rl2:
    "Existe cierto nivel de especificidad en los requisitos para la interacción entre componentes",
  integration_rl3:
    "El diseño detallado de integración se ha definido para incluir todos los detalles de la interfaz",
  integration_rl4:
    "Validación de las funciones de integración de componentes en un entorno de laboratorio",
  integration_rl5:
    "Validación de los componentes integrados en un entorno relevante",
  integration_rl6:
    "Validación de los componentes integrados en un entorno integral relevante",
  integration_rl7:
    "Demostración de la integración de prototipos en un entorno operativo de alta fidelidad",
  integration_rl8: "Prueba y demostración en un entorno operativo",
  integration_rl9:
    "Integración del sistema demostrada mediante capacidades exitosas de operación en misión",
  societal_rl1:
    "Identificación de la necesidad social genérica, el bien social y los aspectos asociados",
  societal_rl2:
    "Formulación del concepto de solución propuesto y de los impactos potenciales",
  societal_rl3:
    "Un grupo limitado de la sociedad conoce la solución o iniciativas similares",
  societal_rl4:
    "Un grupo limitado de la sociedad prueba la solución o iniciativas similares",
  societal_rl5:
    "La sociedad conoce la solución o iniciativas similares, pero no es consciente de sus beneficios",
  societal_rl6:
    "La sociedad conoce la solución y aumenta la conciencia sobre sus beneficios",
  societal_rl7:
    "La sociedad es plenamente consciente de los beneficios de la solución",
  societal_rl8:
    "La sociedad está lista para adoptar la solución y ha utilizado soluciones similares en el mercado",
  societal_rl9:
    "La sociedad está utilizando la solución y esta cuenta con el apoyo de las partes interesadas y del público",
  manufacturing_rl1: "Implicaciones básicas de fabricación identificadas",
  manufacturing_rl2: "Conceptos de fabricación identificados",
  manufacturing_rl3: "Desarrollada la prueba de concepto de fabricación",
  manufacturing_rl4:
    "Capacidad para producir la tecnología en un entorno de laboratorio",
  manufacturing_rl5:
    "Capacidad para producir los componentes prototipo en un entorno relevante para la producción",
  manufacturing_rl6:
    "Capacidad para producir un prototipo de sistema o subsistema en un entorno relevante para la producción",
  manufacturing_rl7:
    "Capacidad para producir sistemas, subsistemas o componentes en un entorno representativo de producción",
  manufacturing_rl8:
    "Capacidad de línea piloto demostrada. Preparado para iniciar una producción de bajo ritmo",
  manufacturing_rl9:
    "Producción de bajo ritmo demostrada. Existe capacidad para iniciar la producción a plena escala",
  commercialisation_rl1: "Investigación e hipótesis de base",
  commercialisation_rl2: "Evaluación del mercado",
  commercialisation_rl3:
    "Validación de la aplicación tecnológica y del mercado",
  commercialisation_rl4: "Propuesta de valor",
  commercialisation_rl5: "Desarrollo del producto y alineación con el mercado",
  commercialisation_rl6:
    "Optimización del producto/solución y protección de la propiedad intelectual",
  commercialisation_rl7: "Validación técnica y comercial",
  commercialisation_rl8:
    "Estrategia de comercialización e introducción en el mercado",
  commercialisation_rl9: "Lanzamiento completo e ingresos por licencias",
  security_rl1: "Consideración de la seguridad",
  security_rl2: "Desarrollo del concepto de seguridad",
  security_rl3: "Seguridad desde el diseño",
  security_rl4: "Preparación de medidas y características de seguridad",
  security_rl5: "Validación simple de seguridad",
  security_rl6: "Demostración secuencial de seguridad",
  security_rl7: "Demostraciones complejas de seguridad",
  security_rl8:
    "Validación final de seguridad previa al lanzamiento y preparación",
  security_rl9: "Seguridad operativa inicial",
  security_rl10: "Seguridad bien establecida/fiable",
  legal_privacy_ethical_rl1:
    "Control sobre cuestiones legales, éticas y de privacidad: el sistema ha implantado mecanismos de control para la rendición de cuentas y ha superado referencias estándar y obtenido certificación, cuando corresponda",
  legal_privacy_ethical_rl2:
    "Tensiones éticas abordadas mediante ética desde el diseño: las consideraciones legales, éticas y de privacidad del sistema se han diseñado para ser compatibles entre sí. Las tensiones éticas se han abordado de modo que mejorar un aspecto no afecte negativamente a otro",
  legal_privacy_ethical_rl3:
    "Interacciones legales, éticas y de privacidad caracterizadas: se han caracterizado las interacciones entre las distintas consideraciones éticas y de privacidad",
  legal_privacy_ethical_rl4:
    "Cuestiones legales, éticas y de privacidad identificadas: se han identificado y anticipado las consideraciones éticas y de privacidad planteadas por el sistema",
  sol_linked_caps: "Capacidades vinculadas (con brechas)",
  sol_addressed_gaps: "Brechas de capacidad abordadas",
  sol_no_gaps:
    "Aún no se han identificado brechas de capacidad. Vaya al Paso 1 para evaluar capacidades.",
  sol_compliance_title: "Verificaciones de cumplimiento",
  sol_status: "Estado",
  sol_pass: "Conforme",
  sol_partial: "Parcial",
  sol_fail: "No conforme",
  sol_na: "N/A",
  sol_not_applicable: "No aplicable",
  sol_user_needs_title: "Evaluación de necesidades de usuarios",
  sol_operational_needs_title: "Evaluación de necesidades operativas",
  sol_organisational_needs_title: "Evaluación de necesidades organizacionales",
  sol_expected_impact_title: "Evaluación del impacto esperado",
  sol_question: "Pregunta",
  sol_response: "Respuesta",
  UN01: "¿Es la solución fácil de usar?",
  UN02: "¿Es probable que la solución funcione adecuadamente bajo presión? Incluida la robustez y fiabilidad.",
  UN03: "¿Es probable que la solución sea aceptada por los usuarios?",
  UN04: "¿Es probable que la solución apoye la comprensión del usuario?",
  UN05: "¿Es probable que la solución apoye la explicabilidad para los usuarios?",
  UN06: "¿Es probable que la solución mejore la eficiencia del usuario?",
  UN07: "¿Es probable que la solución mejore la efectividad del usuario?",
  UN08: "¿Es probable que la solución proporcione conocimiento adicional?",
  UN09: "¿Es probable que la solución produzca consistentemente intervenciones y/o resultados positivos?",
  ON01: "¿Es probable que la solución requiera una (re-)formación extensa?",
  ON02: "¿Es probable que la solución requiera mantenimiento y soporte excesivos?",
  ON03: "¿Es probable que la solución sea compatible con sus métodos operativos/PNT?",
  ON04: "¿Es la solución interoperable?",
  ON05: "¿Es probable que la solución sea adaptable y transferible a sus escenarios operativos?",
  ON06: "¿Es probable que la solución apoye la salud y seguridad de los intervinientes?",
  ON07: "¿Es probable que la solución alcance la población objetivo prevista?",
  ON08: "¿Es probable que la solución ofrezca mayor eficiencia operativa?",
  ON09: "¿Es probable que la solución ofrezca mayor efectividad operativa?",
  OG01: "¿Es probable que la solución tenga un balance costo-beneficio positivo?",
  OG02: "¿Parece factible la solución? Incluyendo tecnológica, económica, legal, operativa y temporalmente.",
  OG03: "¿Es probable que la solución sea compatible con su cultura organizacional?",
  OG04: "¿Es probable que la solución sea compatible con el mandato de su organización?",
  OG05: "¿Es probable que la solución sea compatible con las prioridades de la gobernanza de gestión de crisis?",
  OG06: "¿Apoyaría el uso de la solución su reputación ante el público?",
  OG07: "¿Ayudaría el uso de la solución a mejorar las relaciones con la comunidad?",
  EI01: "¿Se aplicará la solución en el contexto de la atención sanitaria humana?",
  EI02: "¿Implica la solución el tratamiento de datos personales?",
  EI03: "¿Es probable que la solución tenga un impacto negativo en los derechos y libertades de individuos y grupos? P.ej. privacidad, dignidad, autonomía, solidaridad.",
  EI04: "¿Es probable que la solución tenga un impacto negativo en términos de justicia social e igualdad?",
  EI05: "¿Es probable que la solución tenga un impacto negativo en el bienestar de individuos o grupos?",
  EI06: "¿Es probable que la solución aumente la vulnerabilidad de individuos o grupos?",
  EI07: "¿Es probable que la solución plantee riesgos potenciales de seguridad?",
  EI08: "¿Es probable que la solución tenga un impacto negativo en el medio ambiente?",
  EI09: "¿Existe una incertidumbre SIGNIFICATIVA sobre los impactos legales, éticos y sociales del uso de la solución?",
  CC01: "Seguridad (ciber)",
  CC02: "Interoperabilidad",
  CC03: "Reglamento de IA",
  CC04: "Participación comunitaria",
  CC05: "RGPD",
  CC06: "Derechos fundamentales",
  CC07: "Objetivos de desarrollo sostenible",
  CC08: "Prioridades nacionales de gestión de crisis",
  CC09: "Normas sectoriales específicas",
  CC10: "Leyes y reglamentos sectoriales específicos",
  cap_add_from_ref: "Añadir capacidades desde la referencia",
  cap_all_selected:
    "Todas las capacidades de referencia se han añadido a su sesión.",
  cap_add_selected: "Añadir capacidades seleccionadas",
  cap_ref_panel_title: "Capacidades disponibles (modelo de referencia DASF)",
  collapse: "Contraer",
  step0_abbr: "Paso 0: I&P",
  step0_desc:
    "Identificar los tipos de amenazas relevantes para su contexto de evaluación.",
  step1_abbr: "Paso 1: ENB",
  step1_desc:
    "Evaluar capacidades, identificar brechas y necesidades de mejora.",
  step2_abbr: "Paso 2: ES",
  step2_desc: "Evaluar soluciones para las brechas de capacidad identificadas.",
  step3_abbr: "Paso 3: HR",
  step3_desc: "Planificar la hoja de ruta de implementación y compromisos.",
  landing_attribution:
    "DIREKTION ha recibido financiación del programa de investigación e innovación Horizonte Europa de la Unión Europea en virtud del acuerdo de subvención n.° 101121249.",
  landing_developed_by: "Desarrollado por",
  landing_as_part_of: "como parte del",
  landing_project: "proyecto.",
  dasf_purpose_title: "Propósito del DASF",
  dasf_purpose_p1:
    "El Marco de Evaluación y Selección DIREKTION (DASF) es un método central desarrollado dentro del proyecto DIREKTION para apoyar un proceso de selección y evaluación transparente e imparcial.",
  dasf_purpose_offers: "El marco DASF ofrece un método paso a paso para:",
  dasf_purpose_item1: "Identificar y abordar las brechas de capacidades",
  dasf_purpose_item2:
    "Implementar una selección sistemática de tecnologías y soluciones",
  dasf_purpose_item3: "Establecer una hoja de ruta",
  dasf_purpose_p2:
    "El DASF proporciona la base para un proceso sostenible de programación de la investigación, garantizando que los equipos de respuesta y las partes interesadas tengan acceso a las herramientas más efectivas y actualizadas para la preparación y respuesta ante desastres. El conjunto completo está diseñado para ejecutarse regularmente — por ejemplo, una vez al año o una vez cada cuatro años — para obtener una visión actualizada de las necesidades de capacidades más actuales, las brechas de capacidades, las soluciones potenciales y para actualizar regularmente la hoja de ruta para las oportunidades de investigación de la UE o nacionales.",
  landing_assessment_process: "Proceso de evaluación",
  landing_video_tutorial: "Ver el videotutorial en YouTube",
  landing_funded_by: "Financiado por la Unión Europea",
  landing_trilateral_attribution:
    "Para la creación de esta herramienta se utilizaron contribuciones esenciales de Trilateral Research, desarrolladas en el marco de DIREKTION D1.2.",
  delete_session_confirm: "¿Eliminar sesión: {name}?",
  delete_session_warning: "Esta acción no se puede deshacer. ¿Está seguro?",
  N01: "Terremoto",
  N02: "Tsunami",
  N03: "Erupción volcánica",
  N04: "Deslizamiento de tierra / Avalancha",
  N05: "Inundación",
  N06: "Inundación repentina",
  N07: "Tormenta / Huracán / Tornado",
  N08: "Incendio forestal",
  N09: "Temperatura extrema (calor/frío)",
  N10: "Sequía",
  N11: "Epidemia / Pandemia",
  N12: "Brote de enfermedad animal",
  N13: "Infestación de insectos",
  T01: "Accidente industrial (QBRN)",
  T02: "Incidente nuclear / Radiológico",
  T03: "Accidente de transporte (aéreo)",
  T04: "Accidente de transporte (ferroviario)",
  T05: "Accidente de transporte (por carretera)",
  T06: "Accidente de transporte (marítimo)",
  T07: "Tubería / Explosión de gas",
  T08: "Colapso de edificio / estructura",
  T09: "Fallo de presa / dique",
  T10: "Apagón / Fallo de la red eléctrica",
  T11: "Fallo de telecomunicaciones",
  T12: "Contaminación del suministro de agua",
  T13: "Derrame de materiales peligrosos",
  A01: "Ataque terrorista (explosivo)",
  A02: "Ataque terrorista (QBRN)",
  A03: "Ataque cibernético",
  A04: "Tirador activo / Agresión armada",
  A05: "Sabotaje de infraestructura crítica",
  A06: "Toma de rehenes / Secuestro",
  A07: "Disturbios civiles / Motines",
  A08: "Piratería marítima / Secuestro",
  A09: "Ataque con drones",
  A10: "Amenaza híbrida",
  A11: "Campaña de desinformación",
  A12: "Interrupción de la cadena de suministro (intencional)",
  A13: "Incendio provocado",
  "Cat-01": "Mitigación / Prevención",
  "Cat-02": "Preparación",
  "Cat-03": "Respuesta",
  "Cat-04": "Recuperación",
  "Mit-01": "Evaluación de riesgos",
  "Mit-02": "Reducción de la exposición",
  "Mit-03": "Apoyo a la mitigación",
  "Prep-01": "Desarrollo de capacidades",
  "Prep-02": "Vigilancia",
  "Prep-03": "Apoyo a la preparación",
  "Rsp-01": "Supresión del incidente",
  "Rsp-02": "Operaciones de rescate",
  "Rsp-03": "Seguridad / Aplicación de la ley",
  "Rsp-04": "Atención sanitaria de emergencia",
  "Rsp-05": "Comunicación hacia la sociedad",
  "Rsp-06": "Protección de la población / animales",
  "Rsp-07": "Despeje de la zona siniestrada",
  "Rsp-08": "Suministro de necesidades básicas",
  "Rsp-09": "Apoyo a la respuesta",
  "Rec-01": "Recuperación humanitaria",
  "Rec-02": "Recuperación ambiental",
  "Rec-03": "Recuperación económica",
  "Rec-04": "Restablecimiento de infraestructuras",
  "Rec-05": "Apoyo a la recuperación",
  "Mit-RA-01": "Identificación de riesgos",
  "Mit-RA-02": "Análisis de riesgos",
  "Mit-RA-03": "Evaluación de riesgos",
  "Mit-ER-01": "Protección de bienes",
  "Mit-ER-02": "Protección de recursos naturales",
  "Mit-ER-03": "Sensibilización",
  "Mit-MS-01": "Análisis de tendencias",
  "Mit-MS-02": "Seguimiento y revisión",
  "Prep-CD-01": "Planificación de respuesta y recuperación",
  "Prep-CD-02": "Formación",
  "Prep-CD-03": "Comunicación de riesgos",
  "Prep-MO-01": "Detección",
  "Prep-MO-02": "Alerta",
  "Prep-PS-01": "Gestión de personal",
  "Prep-PS-02": "Gestión de activos",
  "Prep-PS-03": "Establecimiento de cooperación",
  "Prep-EH-04": "Atención psicológica",
  "Resp-SI-01": "Extinción de incendios - Infraestructuras",
  "Resp-SI-02": "Extinción de incendios - Naturaleza",
  "Resp-SI-03": "Control de inundaciones",
  "Resp-SI04": "Control de materiales peligrosos (QBRN-E)",
  "Resp-RO-01": "Búsqueda y Rescate (SAR)",
  "Resp-RO-02": "Tratamiento de víctimas in situ",
  "Resp-RO-03": "Transporte de víctimas",
  "Resp-SL-01": "Aseguramiento de lugares / personas",
  "Resp-SL-02": "Identificación de personas",
  "Resp-SL-03": "Medicina forense",
  "Resp-SL-04": "Mantenimiento del orden público",
  "Resp-SL-05": "Gestión del tráfico",
  "Resp-EH-01": "Atención urgente - Hospitales",
  "Resp-EH-02": "Cuarentena",
  "Resp-EH-03": "Salud pública masiva",
  "Resp-CS-01": "Aviso",
  "Resp-CS-02": "Comunicación de crisis",
  "Resp-SF-01": "Evacuación",
  "Resp-SF-02": "Alojamiento",
  "Resp-SF-03": "Reunificación",
  "Resp-DA-01": "Despeje de escombros",
  "Resp-DA-02": "Descontaminación de objetos",
  "Resp-DA-03": "Drenaje",
  "Resp-DA-04": "Destrucción de animales",
  "Resp-BN-01": "Suministro de agua potable",
  "Resp-BN-02": "Suministro de alimentos",
  "Resp-BN-03": "Suministro de energía",
  "Resp-BN-04": "Provisión de TIC / Telecomunicaciones",
  "Resp-BN-05": "Saneamiento",
  "Resp-RS-01": "Mando, Control y Coordinación",
  "Resp-RS-02": "Evaluación de la situación",
  "Resp-RS-03": "Gestión de la información",
  "Resp-RS-04": "Vigilancia / Recopilación de datos",
  "Resp-RS-05": "Apoyo a operaciones in situ",
  "Resp-RS-06": "Logística",
  "Rec-HR-01": "Salud pública y seguridad",
  "Rec-HR-02": "Alimentación y alojamiento",
  "Rec-ER-01": "Gestión de residuos",
  "Rec-ER-02": "Restauración de hábitats",
  "Rec-EC-01": "Recuperación empresarial",
  "Rec-EC-02": "Recuperación financiera",
  "Rec-RI-01": "Restablecimiento del transporte",
  "Rec-RI-02": "Restablecimiento de servicios públicos",
  "Rec-RS-01": "Establecimiento de la organización de recuperación",
  "Rec-RS-02": "Programación de la recuperación",
  "Goal-01": "Prevenir incidentes",
  "Goal-01_desc": "Prevenir desastres / situaciones de crisis.",
  "Goal-02": "Minimizar pérdidas por amenazas",
  "Goal-02_desc": "Reducir / evitar pérdidas por amenazas.",
  "Goal-03": "Ayudar a las víctimas",
  "Goal-03_desc": "Asegurar asistencia rápida y efectiva a las víctimas.",
  "Goal-04": "Recuperación adecuada",
  "Goal-04_desc": "Lograr una recuperación rápida y efectiva.",
  "TO-01": "Bomberos / Protección civil",
  "TO-02": "Policía",
  "TO-03": "Atención sanitaria de emergencia",
  "TO-04": "Defensa",
  "TO-05": "Centro de mando",
  "TO-06": "Autoridades",
  "TO-07": "Infraestructuras críticas",
  "TO-08": "ONG",
  "TO-09": "Otros",
  "SH-01": "Bomberos/Protección civil",
  "SH-02": "Policía",
  "SH-03": "Atención sanitaria de emergencia",
  "SH-04": "SAR",
  "SH-05": "Centro de mando o despacho (112)",
  "SH-06": "Autoridades (ministerios, municipios)",
  "SH-07": "Defensa",
  "SH-08": "Servicios públicos",
  "SH-09": "Guardia costera o Seguridad de fronteras",
  "SH-10": "Operador de infraestructuras críticas",
  "SH-11": "ONG",
  "SH-12": "Otros (a describir)",
  "Imp-1": "Ninguna/Muy baja",
  "Imp-2": "Baja",
  "Imp-3": "Media",
  "Imp-4": "Bastante alta",
  "Imp-5": "Muy alta",
  "PA-1": "Eficacia",
  "PA-1_desc": "Calidad de los resultados, puntualidad, resistencia.",
  "PA-2": "Seguridad de los profesionales",
  "PA-2_desc": "Seguridad física y mental del personal implicado.",
  "PA-3": "Eficiencia",
  "PA-3_desc": "Relación entre costes y resultados.",
  "PSc-1": "Deficiente",
  "PSc-2": "Insatisfactorio",
  "PSc-3": "Moderado",
  "PSc-4": "Satisfactorio",
  "PSc-5": "Bueno",
  "Nat-01": "Tecnológico",
  "Nat-01_desc":
    "P.ej. Tecnologías de detección, mando y control, comunicaciones y coordinación, TIC.",
  "Nat-02": "Humano",
  "Nat-02_desc":
    "P.ej. Cantidad de personal, competencia del personal, formación y educación.",
  "Nat-03": "Organizacional",
  "Nat-03_desc":
    "P.ej. Procedimientos, estructura organizacional, aspectos financieros, acuerdos.",
  "Nat-04": "Regulatorio",
  "Nat-04_desc": "P.ej. Aspectos legales, aspectos formales de normalización.",
  "Kn-01": "Desconocido",
  "Kn-02": "No",
  "Kn-03": "Sí",
  "ASc-01": "Muy bajo",
  "ASc-02": "Bajo",
  "ASc-03": "Moderado",
  "ASc-04": "Alto",
  "ASc-05": "Muy alto",
  "Cat-01_desc":
    "Objetivo: Tomar medidas para limitar la probabilidad y reducir el impacto de un incidente, desastre o crisis.",
  "Cat-02_desc":
    "Objetivo: Desarrollar y mantener la estructura organizacional y las capacidades para llevar a cabo actividades de respuesta y recuperación.",
  "Cat-03_desc": "Objetivo: Salvar vidas y limitar efectos adversos.",
  "Cat-04_desc":
    "Objetivo: Reconstruir y restaurar la vida normal de manera eficiente.",
  "Mit-01_desc": "Identificación, análisis y evaluación de riesgos.",
  "Mit-02_desc":
    "Protección de bienes, recursos naturales y la sociedad en general frente a amenazas.",
  "Mit-03_desc": "Capacidades en apoyo a la mitigación / prevención.",
  "Prep-01_desc":
    "Proceso de desarrollo y mantenimiento de las capacidades de gestión de crisis requeridas.",
  "Prep-02_desc":
    "Determinar el estado de un entorno o situación para permitir la detección de incidentes.",
  "Prep-03_desc": "Capacidades en apoyo al desarrollo de capacidades.",
  "Rsp-01_desc":
    "Actividades in situ para detener o contener la causa del desastre.",
  "Rsp-02_desc": "Actividades in situ para salvar vidas.",
  "Rsp-03_desc":
    "Aseguramiento de áreas/personas, identificación de personas, medicina forense.",
  "Rsp-04_desc": "Actividades externas para salvar vidas.",
  "Rsp-05_desc": "Aviso y comunicación de crisis.",
  "Rsp-06_desc": "Evacuación controlada de personas y/o animales.",
  "Rsp-07_desc": "Garantizar accesibilidad y seguridad en la zona afectada.",
  "Rsp-08_desc":
    "Suministro y/o restablecimiento de productos básicos y servicios de vital importancia.",
  "Rsp-09_desc":
    "Capacidades para habilitar una o más capacidades de respuesta.",
  "Rec-01_desc":
    "Provisión de servicios de salud pública, seguridad y alojamiento.",
  "Rec-02_desc": "Eliminación de contaminación y descontaminación.",
  "Rec-03_desc": "Recuperación económica y empresarial.",
  "Rec-04_desc": "Restauración de rutas de transporte y servicios esenciales.",
  "Rec-05_desc":
    "Capacidades necesarias para una recuperación bien coordinada.",
  "Mit-RA-01_desc":
    "Proceso de búsqueda, reconocimiento y descripción de riesgos.",
  "Mit-RA-02_desc":
    "Proceso para comprender la naturaleza del riesgo y determinar el nivel de riesgo.",
  "Mit-RA-03_desc":
    "Proceso de comparación de resultados del análisis de riesgos con criterios de riesgo para determinar si el riesgo es aceptable o tolerable.",
  "Mit-ER-01_desc":
    "Protección de bienes (incluidas infraestructuras críticas).",
  "Mit-ER-02_desc":
    "Acciones que minimizan las pérdidas por amenazas y preservan o restauran las funciones de los sistemas naturales.",
  "Mit-ER-03_desc":
    "Educación pública y sensibilización sobre amenazas y formas potenciales de mitigarlas.",
  "Mit-MS-01_desc": "Investigación de la evolución de los riesgos.",
  "Mit-MS-02_desc":
    "Asegurar que los controles sean efectivos y eficientes, obteniendo información adicional para mejorar la evaluación de riesgos.",
  "Prep-CD-01_desc":
    "Desarrollar, compilar y mantener procedimientos e información listos para usar en un incidente.",
  "Prep-CD-02_desc":
    "Actividades para facilitar el aprendizaje y desarrollo de conocimientos, habilidades y capacidades para la respuesta ante desastres.",
  "Prep-CD-03_desc":
    "Comunicar e instruir al público sobre cómo estar bien preparado para una crisis y cómo comportarse cuando ocurre.",
  "Prep-MO-01_desc": "Detección de circunstancias que se desvían de lo normal.",
  "Prep-MO-02_desc":
    "Alertar al personal sobre la presencia de un incidente y permitir el inicio de acciones de control.",
  "Prep-PS-01_desc":
    "Actividades para proporcionar suficiente personal calificado para llevar a cabo tareas de respuesta y recuperación.",
  "Prep-PS-02_desc":
    "Actividades para proporcionar equipos, herramientas, TIC y otros activos necesarios para la respuesta y recuperación.",
  "Prep-PS-03_desc":
    "Establecimiento de cooperación internacional entre servicios de emergencia y terceros.",
  "Prep-EH-04_desc":
    "Atención de salud psicológica a víctimas, familiares y otras personas afectadas por el incidente.",
  "Resp-SI-01_desc":
    "Extinción de incendios en edificios, zonas urbanizadas o infraestructuras.",
  "Resp-SI-02_desc": "Extinción de incendios en entornos naturales.",
  "Resp-SI-03_desc":
    "Gestión del agua en caso de inundación por rotura de dique o lluvias intensas.",
  "Resp-SI04_desc":
    "Detener el derrame de materiales peligrosos, incluyendo el confinamiento (incidentes QBRN-E).",
  "Resp-RO-01_desc": "Operaciones de búsqueda y rescate.",
  "Resp-RO-02_desc": "Triaje, descontaminación y estabilización de víctimas.",
  "Resp-RO-03_desc": "Transporte en ambulancia a zonas seguras u hospitales.",
  "Resp-SL-01_desc":
    "Proteger áreas, infraestructuras y personas de partes no implicadas.",
  "Resp-SL-02_desc": "Identificación de víctimas.",
  "Resp-SL-03_desc":
    "Actividades forenses para investigar la causa del incidente y salvaguardar evidencias.",
  "Resp-SL-04_desc": "Control de disturbios, etc.",
  "Resp-SL-05_desc":
    "Control del tráfico entrante y saliente de la zona afectada.",
  "Resp-EH-01_desc":
    "Servicio sanitario en hospitales regulares y/o de campaña.",
  "Resp-EH-02_desc":
    "Aislamiento de personas/víctimas potencialmente infecciosas.",
  "Resp-EH-03_desc":
    "Profilaxis masiva o vacunación en caso de incidente nuclear o pandemia.",
  "Resp-CS-01_desc":
    "Advertir a la sociedad en la zona amenazada proporcionando información oportuna y adecuada sobre la amenaza.",
  "Resp-CS-02_desc":
    "Proporcionar información sobre el desastre a la sociedad, incluyendo gestión de voluntarios y llamamientos.",
  "Resp-SF-01_desc":
    "Evacuación controlada de personas y animales de una zona o edificio.",
  "Resp-SF-02_desc":
    "Provisión de alojamiento a evacuados, incluida nutrición y saneamiento.",
  "Resp-SF-03_desc": "Reunificación de evacuados con sus familiares.",
  "Resp-DA-01_desc": "Eliminación de escombros y/o material contaminado.",
  "Resp-DA-02_desc":
    "Descontaminación de zonas, infraestructuras y/o vehículos contaminados.",
  "Resp-DA-03_desc": "Drenaje y bombeo de zonas o infraestructuras inundadas.",
  "Resp-DA-04_desc": "Destrucción de animales posiblemente infectados.",
  "Resp-BN-01_desc": "Restauración o provisión temporal de agua potable.",
  "Resp-BN-02_desc": "Provisión temporal de alimentos.",
  "Resp-BN-03_desc":
    "Restauración del suministro de electricidad/gas o provisión de energía alternativa temporal.",
  "Resp-BN-04_desc":
    "Restauración o suministro temporal de TIC y telecomunicaciones.",
  "Resp-BN-05_desc":
    "Restaurar el saneamiento o proporcionar soluciones temporales.",
  "Resp-RS-01_desc":
    "Toma de decisiones, planificación y asignación de tareas en niveles de coordinación y mando durante un evento de desastre.",
  "Resp-RS-02_desc":
    "Desarrollo de información operativa mediante el enriquecimiento de datos recopilados, incluido el cuadro operativo común.",
  "Resp-RS-03_desc":
    "Almacenamiento y compartición de información como datos recopilados, evaluaciones y decisiones tomadas.",
  "Resp-RS-04_desc":
    "Recopilación de datos mediante vigilancia física y minería de datos.",
  "Resp-RS-05_desc":
    "Provisión de servicios básicos a los primeros intervinientes in situ para posibilitar actividades de respuesta.",
  "Resp-RS-06_desc":
    "Transporte de personal y material para apoyar operaciones prolongadas de respuesta ante desastres.",
  "Rec-HR-01_desc":
    "Provisión de servicios de salud pública y seguridad para los desplazados.",
  "Rec-HR-02_desc":
    "Provisión de alimentos y alojamiento para los desplazados.",
  "Rec-ER-01_desc":
    "Eliminación de contaminación a gran escala y descontaminación, y gestión de residuos.",
  "Rec-ER-02_desc": "Restauración de recursos naturales y hábitats.",
  "Rec-EC-01_desc":
    "Recuperación empresarial de comercios e industrias afectados por el desastre.",
  "Rec-EC-02_desc": "Recuperación del impacto financiero en las autoridades.",
  "Rec-RI-01_desc":
    "Restablecimiento de rutas de transporte (carretera, ferroviario, acuático, aéreo, tuberías).",
  "Rec-RI-02_desc":
    "Restauración de servicios públicos interrumpidos y otros servicios esenciales.",
  "Rec-RS-01_desc":
    "Establecimiento de la estructura organizacional de recuperación para el corto y largo plazo.",
  "Rec-RS-02_desc":
    "Determinación e implementación del programa de recuperación basado en la evaluación de impactos.",
  manage_capabilities: "Seleccionar capacidades",
  select_capabilities_instr:
    "Seleccione las capacidades que desea evaluar para las brechas.",
  drawer_hazards: "Amenazas",
  drawer_gaps: "Brechas",
  drawer_solutions: "Soluciones",
  drawer_roadmap: "Hoja de ruta",
  drawer_capabilities: "Capacidades",
  drawer_solution: "Solución",
  drawer_with_gaps: "con brechas",
  drawer_no_linked_caps: "Sin capacidades vinculadas",
  drawer_add_to_roadmap: "Añadir a la hoja de ruta →",
  drawer_go_to_solutions: "Ir a soluciones →",
  drawer_go_to_roadmap: "Ir a la hoja de ruta →",
  drawer_none: "Ninguno",
  drawer_relevant_hazards: "Amenazas relevantes",
  action_priority: "Prioridad de acción",
  action_priority_instr:
    "Evalúe su disposición a actuar para mejorar esta capacidad (1 = bajo, 5 = urgente)",
  action_priority_label_1: "Ahora no",
  action_priority_label_3: "Quizás",
  action_priority_label_5: "Urgente",
  prev_cap: "Anterior",
  next_cap: "Siguiente",
  about_markdown: `#### DIREKTION Assessment & Screening Framework (DASF)

El conjunto de herramientas DASF apoya el proceso sistemático de evaluación y detección para la gestión de desastres. Proporciona un enfoque estructurado de 4 pasos:

1. **Iniciación y Preparación (I&P)**: Identifique los tipos de peligro relevantes y defina el alcance de la evaluación.
2. **Evaluación de Necesidades y Brechas (ENB)**: Evalúe las capacidades en el ciclo de gestión de desastres, identifique las brechas y las necesidades de mejora.
3. **Evaluación de Soluciones (ES)**: Evalúe las soluciones potenciales para las brechas de capacidad identificadas, incluido el cumplimiento normativo, las necesidades de los usuarios y la evaluación del impacto.
4. **Hoja de Ruta (HR)**: Planifique los cronogramas de implementación y los compromisos para las soluciones seleccionadas.

##### Comenzar

- Cree o abra una sesión de evaluación desde la página de inicio
- Navegue a través de los 4 pasos utilizando los iconos de la barra de herramientas
- Cambie entre los roles de Usuario y Editor usando el selector a continuación

##### Funciones

- **Usuario Regular**: Puede completar evaluaciones y ver resultados
- **Moderador**: Puede editar la configuración del marco (tipos de peligro, capacidades, partes interesadas)
- **Administrador**: Puede modificar las escalas de evaluación y la configuración

##### Antecedentes

Este proyecto ha recibido financiación del programa de investigación e innovación Horizon 2020 de la Unión Europea. Desarrollado por TNO como parte del proyecto [DIREKTION](https://www.direktion-network.org).`,

  // ── Collaboration (EN fallback) ────────────────────────────────────────────
  COLLABORATE: {
    TITLE: "Collaborate",
    ROUTE: "/collaborate",
    PAGE: "Collaboration",
  },
  FACILITATOR: "Facilitator",
  collab_page_title: "Collaboration",
  collab_send_invite: "Send Invite",
  collab_load_patch: "Load Patch",
  collab_mode_ca: "Capability Assessment",
  collab_mode_sc: "Solution Creation",
  collab_mode_sa: "Solution Assessment",
  collab_select_modes: "Select collaboration modes",
  collab_your_name: "Your name",
  collab_your_email: "Your email",
  collab_facilitator_name: "Facilitator name",
  collab_facilitator_email: "Facilitator email",
  collab_custom_message: "Optional message",
  collab_generate_link: "Send Invite by Email",
  collab_done: "Listo - Enviar resultados",
  collab_patch_loaded: "Patch loaded",
  collab_patches_count: {
    1: "1 patch received",
    n: "{n} patches received",
  },
  collab_hash_mismatch:
    "Warning: This patch was created from a different version of the model.",
  collab_session_mismatch:
    "This patch belongs to a different session and cannot be loaded.",
  collab_duplicate_ignored: "Duplicate patch ignored (already loaded).",
  collab_aggregated_results: "Aggregated Results",
  collab_apply_results: "Apply to model",
  collab_no_patches: "No patches received yet.",
  collab_invited_by: "You have been invited by {name} ({email}) to contribute.",
  collab_paste_patch: "Paste a patch link here",
  collab_load_patch_btn: "Load",
  collab_remove_patch: "Remove",
  collab_contributor: "Contributor",
  collab_received_at: "Received at",
  collab_avg_action_priority: "Avg. action priority",
  collab_task_items: "Task importance answers",
  collab_perf_items: "Performance answers",
  collab_gap_items: "Gap answers",
  collab_all_values: "All values",
  collab_avg_value: "Average",
  collab_invite_subject: "Invitation to collaborate on capability assessment",
  collab_invite_body:
    "Dear colleague,\n\nYou are invited to contribute to a capability assessment for {facilitatorName}.\n\nPlease click the link below to open the assessment tool and fill in your responses. When you are done, click the 'Done' button to send your results back.\n\nThis link is valid for one-time use — please do not share it.\n\nKind regards,\n{facilitatorName}",
  collab_patch_subject: "Capability assessment completed",
  collab_patch_body:
    "Dear {facilitatorName},\n\nI have completed the capability assessment you sent me.\n\nPlease click the link below to load my responses into the tool.\n\nKind regards,\n{userName}",
  // ── End Collaboration ───────────────────────────────────────────────────────
};
